export default __webpack_public_path__ + "static/media/BONUS Access to 12 Self-Assessments.4d0676a1.webp";